import {
  SmplAvatar,
  StarAvatar,
  fetchCreateAnonymousAvatarFromSmpl,
  fetchCreateAnonymousAvatarFromStar,
} from '../../avatars';
import { HomeDispatch, HomeGetState } from '../store/homeStore';
import { resetAvatar, updateAvatar } from './homeAvatar';
import { beginAvatarPoll } from './homeAvatarPoll';

/**
 * Set avatar from SMPL.
 * @param dispatch Redux dispatch function.
 * @param getState Redux state accessor.
 * @param shape Avatar shape.
 */
export async function setAvatarFromSmpl(
  dispatch: HomeDispatch,
  getState: HomeGetState,
  shape: SmplAvatar,
) {
  // Reset avatar.
  resetAvatar(dispatch, getState);

  // Fetch avatar from SMPL.
  const avatar = await fetchCreateAnonymousAvatarFromSmpl(shape);

  // Update avatar.
  updateAvatar(dispatch, avatar);
}

/**
 * Set avatar from STAR.
 * @param dispatch Redux dispatch function.
 * @param getState Redux state accessor.
 * @param shape Avatar shape.
 */
export async function setAvatarFromStar(
  dispatch: HomeDispatch,
  getState: HomeGetState,
  shape: StarAvatar,
) {
  // Reset avatar.
  resetAvatar(dispatch, getState);

  // Fetch avatar from STAR.
  const avatar = await fetchCreateAnonymousAvatarFromStar(shape);

  // Pending SMPL shape status start poll.
  if (avatar.smplShapeStatus === 'PENDING') {
    beginAvatarPoll(dispatch, avatar.id);
    return;
  }

  // Update avatar.
  updateAvatar(dispatch, avatar);
}
